import React from "react";
import Paginator from "Components/Common/PaginatorWithApi";

function CSTablePagination(props: {
    paginationParams: { page: number, per_page: number },
    updatePageSize: (size: number) => void,
    handlePageChange: (page: number) => void,
    totalRecords: number
},
) {

    return (<>
        <div className="tw-mb-4">
            <div className="tw-flex tw-justify-end tw-align-bottom">
                <select className="tw-h-min tw-w-[70px] tw-border tw-p-1 tw-rounded-sm tw-mt-2" aria-label="Default select example"
                    defaultValue={props?.paginationParams?.per_page}
                    onChange={(e) => props?.updatePageSize(parseInt(e.target.value))}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={10000}>All</option>
                </select>
                <Paginator
                    onPageChange={props?.handlePageChange}
                    recordPerPage={props?.paginationParams?.per_page}
                    presentPage={props?.paginationParams?.page}
                    totalRecords={props?.totalRecords} />
            </div>
        </div>

    </>
    );
}

export default CSTablePagination